{
  "brand": "BidNova Auctions",
  "browse": "オークションを見る",
  "trends": "相場動向",
  "community": "コミュニティ",
  "watchlist": "ウォッチリスト",
  "wantList": "探しているカード",
  "myBids": "入札履歴",
  "orders": "注文",
  "sell": "出品する",
  "signIn": "ログイン",
  "join": "新規登録",
  "signOut": "ログアウト",
  "account": "アカウント",
  "accountMenu": "{name} のアカウントメニュー",
  "dashboard": "ダッシュボード",
  "accountProfile": "アカウントとプロフィール",
  "sellerDashboard": "出品者ダッシュボード",
  "myAuctions": "出品中のオークション",
  "orderCentre": "注文センター",
  "collection": "コレクション",
  "notifications": "お知らせ",
  "admin": "管理画面",
  "language": "言語",
  "changeLanguage": "言語を変更",
  "footer": {
    "tagline": "英国を代表する鑑定済みポケモンカード・トレーディングカードのマーケットプレイス。GBP建てのライブオークションを Stripe が保護し、英国 GDPR に完全準拠しています。",
    "marketplace": "マーケットプレイス",
    "browseAuctions": "オークションを見る",
    "marketTrends": "相場動向",
    "sellCard": "カードを出品",
    "community": "コミュニティ",
    "communityHub": "コミュニティハブ",
    "articles": "ニュース・記事",
    "events": "英国カードショー",
    "dealers": "ディーラー一覧",
    "categories": "人気カテゴリー",
    "legal": "法的情報",
    "terms": "利用規約",
    "privacy": "プライバシー",
    "cookies": "Cookie",
    "buyerTerms": "購入者規約",
    "sellerAgreement": "出品者規約",
    "refunds": "返金と紛争解決",
    "cookieSettings": "Cookie 設定",
    "contact": "お問い合わせ",
    "registered": "イングランド及びウェールズ登記",
    "trusted": "安心・安全",
    "stripeSecured": "Stripe による保護",
    "gdpr": "GDPR",
    "cards": "カード・Apple Pay",
    "rights": "© 2026 BidNova Auctions. All rights reserved.",
    "governed": "イングランド及びウェールズ法に準拠 · 表示価格は GBP（£）"
  },
  "home": "ホーム",
  "tradingCards": "トレカ",
  "collectibles": "コレクタブル",
  "fashion": "ファッション",
  "sealedProducts": "未開封商品",
  "accessories": "アクセサリー",
  "sellAnItem": "出品する",
  "searchPlaceholder": "カード、フィギュア、ファッションなどを検索…"
}
